export default __webpack_public_path__ + "static/media/portefolio.85071189.png";